import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Box, Flex, Grid, Heading, StyleProps } from '@chakra-ui/react';

interface SummaryContainerProps {
  columns?: number;
  rows?: number;
}

interface WhiteBoxProps extends StyleProps {
  transparent: boolean;
}

const MotionBox = motion(Box);

export const WhiteBox = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => prop !== 'transparent',
  })
  .attrs((props: WhiteBoxProps) => ({
    // padding: 3,
    py: 3,
    px: props.transparent ? 3 : 3,
    ...(props.transparent
      ? {}
      : {
          bg: props.bg || 'white',
          // boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.1)',
          borderWidth: 1,
          borderColor: 'grey.50',
        }),
    borderRadius: 8,
  }))``;

export const Container = styled(WhiteBox).attrs({
  width: '100%',
  flex: 1,
})``;

export const SeparatedContent = styled(WhiteBox).attrs({
  marginBottom: 3,
})``;

export const SeparatedContainer = styled(MotionBox).attrs({
  width: '100%',
  height: '100%',
  marginBottom: 10,
  flex: 1,
  transition: { duration: 0.3 },
})``;

export const Header = styled(Flex).attrs({
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  borderBottom: '1px solid rgb(44, 44, 44, 0.1)',
  paddingBottom: 2,
  marginBottom: 3,
})``;

export const SeparatedHeader = styled(WhiteBox).attrs((props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: { base: 'column', md: 'row' },
  alignItems: 'center',
  width: '100%',
  marginBottom: props.marginBottom ? props.marginBottom : 3,
  px: props.transparent ? 3 : 3,
  py: 4,
  fontSize: 'sm',
}))``;

export const SummaryContainer = styled(Grid).attrs({
  width: '100%',
  marginBottom: 3,
  borderRadius: 8,
  templateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  // templateRows: { base: '1fr', md: `repeat(${props.rows || 1}, 1fr)` },
  gap: 3,
})``;

export const GridContainer = styled(Grid).attrs(
  (props: SummaryContainerProps) => ({
    display: { base: 'grid' },
    width: '100%',
    marginBottom: 3,
    borderRadius: 8,
    templateColumns: { base: '1fr', md: `repeat(${props.columns || 1}, 1fr)` },
    templateRows: { base: '1fr', md: `repeat(${props.rows || 1}, 1fr)` },
    gap: 3,
  }),
)``;

export const Actions = styled(Flex).attrs({
  justifyContent: 'flex-end',
  alignItems: 'center',
})``;

export const Title = styled(Heading).attrs({
  fontSize: 'xl',
  color: 'gray.700',
  fontWeight: 600,
  mb: { base: 4, md: 0 },
})``;
